import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-main",
  "use": "icon-main-usage",
  "viewBox": "0 0 1107 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1107 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-main\"><defs><style type=\"text/css\"></style></defs><path d=\"M229.748364 1023.906909V342.760727c0-27.159273-20.875636-48.058182-45.940364-48.058182H45.963636c-25.041455 0-45.940364 22.970182-45.940363 48.058182v681.146182h229.725091z m292.375272 0V50.245818c0-27.182545-20.875636-50.152727-45.940363-50.152727h-137.844364c-25.064727 0-45.940364 22.970182-45.940364 50.152727v973.661091h229.725091z m292.375273 0V593.477818c0-27.159273-20.875636-50.129455-45.940364-50.129454h-137.82109c-25.064727 0-45.963636 22.970182-45.963637 50.129454v430.429091h229.725091z m292.375273 0V342.760727c0-27.159273-20.875636-48.058182-45.940364-48.058182h-137.844363c-25.041455 0-45.940364 22.970182-45.940364 48.058182v681.146182h229.725091z\" p-id=\"1966\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/main.svg
// module id = Kbpm
// module chunks = 12